export const generatePlaceholder = (placeholder?: string, label?: string) =>
  placeholder ?? label ?? "";
